import { themr } from 'react-css-themr';
import UserMenuItem from './UserMenuItem';
import { iconFactory } from 'common/components/core/icon/IconFactory';
import { IconMenu, MenuItem, MenuDivider, Menu } from 'react-toolbox/lib/menu';
import theme from './Menu.scss';

const IconMenuWithCustomIcon = iconFactory({ Component: IconMenu });

const ThemedIconMenu = themr(
    'IconMenuWithCustomIcon',
    theme
)(IconMenuWithCustomIcon);
const ThemedMenuItem = themr('MenuItem', theme)(MenuItem);

export { ThemedMenuItem as MenuItem };
export { MenuDivider };
export { Menu };

export { UserMenuItem };
export { ThemedIconMenu as IconMenu };
